import React from 'react';
import useStyles from "./styles";
import PropTypes from "prop-types";

const FieldData = ({ label, children }) => {

    const classses = useStyles();

    return (
        <div className={classses.fieldData}>
            <label>{label}</label>
            <div>{children}</div>
        </div>
    );
};

export const FieldDataInnerField = ({ label, children }) => {

    const classses = useStyles();

    return (
        <div className={classses.fieldDataInner}>
            <label>{label}</label>
            <div>{children}</div>
        </div>
    );
}

FieldDataInnerField.propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired,
};

FieldData.propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired,
};

export default FieldData;